
import React from "react";
import "./pagestyles/LearnMore.css";


const LearnMore = () => {
  return (
    <>
      <div className="page-container">
        <div className="page-header">
          <h1>Redbox Global Events</h1>
          <p className="page-subtitle">
            Discover our global investment, technology, and finance summits
          </p>
        </div>

        <div className="page-content">
          <div className="content-grid">

            <div className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600&h=400&fit=crop" alt="Invest Summit"/>
              </div>
              <div className="article-content">
                <span className="article-category">Finance</span>
                <h2>Redbox Invest Summit 2026</h2>
                <p>
                  Join global investors, hedge funds and financial leaders
                  discussing the future of global capital markets.
                </p>
                <span className="article-meta">March 3–4, 2026 • New York</span>
              </div>
            </div>

            <div className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=600&h=400&fit=crop" alt="Energy Forum"/>
              </div>
              <div className="article-content">
                <span className="article-category">Energy</span>
                <h2>Global Energy Forum</h2>
                <p>
                  Industry leaders and policymakers discuss the future of
                  global energy markets and sustainability.
                </p>
                <span className="article-meta">June 12–14, 2026 • Doha</span>
              </div>
            </div>

            <div className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&h=400&fit=crop" alt="Finance Expo"/>
              </div>
              <div className="article-content">
                <span className="article-category">Finance</span>
                <h2>Future Finance Expo</h2>
                <p>
                  Explore the future of fintech, digital assets, and global
                  financial infrastructure.
                </p>
                <span className="article-meta">Sept 8–10, 2026 • Singapore</span>
              </div>
            </div>

          </div>
        </div>
      </div>

     
    </>
  );
};

export default LearnMore;